import { useAsyncData, useDataTracking, useLogger, useMaltVisitorId, useUniversalFetch } from "#imports";
import { defineStore } from "pinia";
import { ref } from "vue";
export function createABTestStore(storeName = "abtest-store") {
  return defineStore(storeName, () => {
    const campaigns = ref({});
    const logger = useLogger();
    const maltVisitorId = useMaltVisitorId();
    const { track } = useDataTracking();
    async function fetchCampaignsVariations() {
      logger.debug("Loading campaigns variations");
      const { data, error } = await useAsyncData(
        "abtest-campaigns-variations",
        () => useUniversalFetch(`/public-api/experiment/campaigns?maltVisitorId=${maltVisitorId.value}`)
      );
      if (error.value) {
        logger.error(`Error while fetching campaigns variations for visitor ${maltVisitorId.value}`, error.value);
      }
      campaigns.value = data.value;
    }
    function getVariation(campaignId) {
      const variationId = getVariationWithoutTracking(campaignId);
      if (variationId) {
        track("$exposure", { flag_key: campaignId, variant: variationId });
      }
      return variationId;
    }
    function getVariationWithoutTracking(campaignId) {
      if (!campaigns.value) {
        logger.error("Campaigns should not be null");
        return null;
      }
      return campaigns.value[campaignId];
    }
    return {
      campaigns,
      fetchCampaignsVariations,
      getVariationWithoutTracking,
      getVariation
    };
  });
}
